import { FileText, LockKeyhole, Zap } from 'lucide-react';
import { Button } from '../ui/button';
import covers from '../../generated/pdf-covers.json';
import { mediaSrc } from './shopImages';

export const ShopLanguage = ({ shop }) => (
  <div className="shop-language" role="group" aria-label={shop.t.language} data-testid="shop-language">
    {['fr', 'pt'].map(lang => <button type="button" key={lang} lang={lang} onClick={() => shop.setLang(lang)}
      aria-label={lang === 'fr' ? 'Français' : 'Português'} aria-pressed={shop.lang === lang}
      data-testid={`shop-language-${lang}`}>{lang.toUpperCase()}</button>)}
  </div>
);

export const ShopCover = ({ product, t, lang = 'fr' }) => {
  const source = product.covers?.[lang] || covers[product.id]?.[lang];
  if (source) return <div className="shop-cover shop-cover-image" data-testid={`shop-cover-${product.id}`}><img src={mediaSrc(source)} alt={product[lang]?.name || product.fr.name} data-testid={`shop-cover-image-${product.id}`} loading="lazy"/></div>;
  return <div className={`shop-cover shop-cover-${product.kind}`} data-testid={`shop-cover-${product.id}`}>
    <span className="shop-cover-brand">Studio Euclides</span>
    <div className="shop-cover-center"><FileText size={28} strokeWidth={1} aria-hidden="true"/><span>{t.cover}</span></div>
    <span className="shop-cover-number">{product.number}<span> / PDF</span></span>
  </div>;
};

export const ShopMeta = ({ product, t }) => (
  <div className="shop-meta" data-testid={`shop-meta-${product.id}`}>
    <span><Zap size={13} aria-hidden="true"/>{product.flash_counts.length > 1 ? t.range : t.flash(product.flash_counts[0])}</span>
    <span>{product.pages} {t.pages} · A4</span>
  </div>
);

export const ShopAvailability = ({ product, t }) => (
  <div className="shop-availability">
    <Button disabled className="shop-disabled" data-testid={`shop-unavailable-${product.id}`}>
      <LockKeyhole size={14} aria-hidden="true"/>{t.available}
    </Button>
    {product.price_chf === 0 && <p data-testid="shop-free-note">{t.freeNote}</p>}
  </div>
);